import { useCallback } from 'react';
import { FaEuroSign } from 'react-icons/fa6';
import { Link, useParams } from 'react-router-dom';
import { Input } from 'rizzui';
import { Loader } from '../../../components/loader/SpinnerLogo';
import useFetch from '../../../hooks/useFetch';
import Page from '../../../layout/Page/Page';
import FormGroup from '../../../layout/shared/form-group';
import { menuRoutes } from '../../../router/menu';
import { ExpirationService } from '../../../services/expiration/expirationService';
import { fixNumber } from '../../../utils/formatNumber';
import PageHeader from '../../../layout/shared/page-header';

const ViewExpiration = () => {
    const { id = '' } = useParams<{ id: string }>();
    const service = new ExpirationService();

    const [data, loading] = useFetch(useCallback(async () => {
        if (!id) return null;
        const response = await service.getExpiration(id);
        const resData = response.getResponseData();
        return resData?.data ?? resData;
    }, [id]));

    const pageHeader = {
        title: 'Vencimiento',
        breadcrumb: [
            { name: 'Ventas' },
            { name: 'Gestión de contratos' },
            { name: 'Vencimientos', href: menuRoutes.expirations.path },
            { name: 'Ver Vencimiento' },
        ],
    };

    if (loading) return <Loader />;

    return (
        <Page container="fluid">
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />

            {data && (
                <div className="@container">
                    <div className="grid gap-7 divide-y-2 divide-dashed divide-gray-200">
                        <FormGroup
                            title="Información General"
                            description="Datos principales del vencimiento"
                            className='pt-3 pb-4'
                            titleCols="@md:col-span-2"
                            childCols="@md:col-span-10 md:grid-cols-2"
                        >
                            <Input
                                readOnly
                                label="Descripción"
                                value={data?.description}
                            />
                            <Input
                                readOnly
                                label="Importe"
                                value={fixNumber(data?.amount)}
                                suffix={<FaEuroSign />}
                            />
                            <Input
                                readOnly
                                label="Estado"
                                value={data?.currentDueStatus?.name}
                            />
                            <Input
                                readOnly
                                label="Estado de Gestión"
                                value={data?.currentDueManagementStatus?.name}
                            />
                            {data?.invoice && (
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Factura</label>
                                    <Link
                                        to={`${menuRoutes.invoices.path}/${data.invoice.id}/profile/info`}
                                        className="text-primary btn-sm"
                                    >
                                        {data.invoice.number}
                                    </Link>
                                </div>
                            )}
                            {data?.contract && (
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Contrato</label>
                                    <Link
                                        to={`${menuRoutes.contracts.path}/${data.contract.id}/profile/info`}
                                        className="text-primary btn-sm"
                                    >
                                        {data.contract.code}
                                    </Link>
                                </div>
                            )}
                            {data?.lastExpirationKoReason && (
                                <div className="md:col-span-2">
                                    <Input
                                        readOnly
                                        label="Motivo de KO"
                                        value={data.lastExpirationKoReason.name}
                                    />
                                    {data.lastExpirationKoReason.description && (
                                        <Input
                                            readOnly
                                            label="Descripción del motivo de KO"
                                            value={data.lastExpirationKoReason.description}
                                            className="mt-2"
                                        />
                                    )}
                                </div>
                            )}
                        </FormGroup>
                    </div>
                </div>
            )}
        </Page>
    );
};

export default ViewExpiration;
